import { configureStore } from '@reduxjs/toolkit';
import ToggleReducer from './Slices/ToggleSlice';
import adminReducer from './Slices/adminSlice';
import creditReducer from './Slices/creditSlice';
import userReducer from './Slices/userSlice';
import projectReducer from './Slices/projectSlice';
import logsReducer from './Slices/logsSlice';
import publicReducer from './Slices/publicSlice';
import ragnarokReducer from './Slices/ragnarokSlice';
import orderReducer from './Slices/orderSlice';

import deploymentReducer from './Slices/deploymentSlice';

import billingReducer from './Slices/Tenant/Billing';
import tenantDeploymentReducer from './Slices/Tenant/Deployments';
import bookingReducer from './Slices/Tenant/Booking';

import adminBookingReducer from './Slices/Admin/ManagerBooking'
import packageReducer from './Slices/Admin/ManagerPackage';
import tenantReducer from './Slices/Admin/ManagerTenant';
import chatbotReducer from './Slices/Admin/ManagerChatbot';
import configReducer from './Slices/configSlice';

export const store = configureStore({
    reducer: {
        toggle: ToggleReducer,
        admin: adminReducer,
        user: userReducer,
        projects: projectReducer,
        credits: creditReducer,
        logs: logsReducer,
        public: publicReducer,
        ragnarok: ragnarokReducer,
        order: orderReducer,

        deploy: deploymentReducer,
        adminPackage: packageReducer,
        adminTenant: tenantReducer,
        adminBooking: adminBookingReducer,
        billing: billingReducer,
        tenantDeployment: tenantDeploymentReducer,
        booking: bookingReducer,
        chatbot: chatbotReducer,
        config: configReducer
  },
});
